function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"])
    return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r))
    return _arrayLikeToArray(r); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, MenuItem, Box, Typography, Divider } from '@mui/material';
import { ConfigurationAPI } from '../../apis';
import { CONFIGURATION_TYPE_LABELS, VALUE_TYPE_LABELS } from '../../constants/configuration';
import { constants } from '../../constants';
var AddConfigurationModal = function AddConfigurationModal(_ref) {
    var open = _ref.open, onClose = _ref.onClose, onSaved = _ref.onSaved, configuration = _ref.configuration, itemIndex = _ref.itemIndex, _ref$existingConfigur = _ref.existingConfigurations, existingConfigurations = _ref$existingConfigur === void 0 ? [] : _ref$existingConfigur;
    var _useState = useState(''), _useState2 = _slicedToArray(_useState, 2), selectedType = _useState2[0], setSelectedType = _useState2[1];
    var _useState3 = useState(''), _useState4 = _slicedToArray(_useState3, 2), key = _useState4[0], setKey = _useState4[1];
    var _useState5 = useState(''), _useState6 = _slicedToArray(_useState5, 2), value = _useState6[0], setValue = _useState6[1];
    var _useState7 = useState('string'), _useState8 = _slicedToArray(_useState7, 2), valueType = _useState8[0], setValueType = _useState8[1];
    var _useState9 = useState(false), _useState0 = _slicedToArray(_useState9, 2), loading = _useState0[0], setLoading = _useState0[1];
    var _useState1 = useState({}), _useState10 = _slicedToArray(_useState1, 2), errors = _useState10[0], setErrors = _useState10[1];
    var isEditMode = !!configuration && itemIndex !== null && itemIndex !== undefined;
    // Effect to populate form when in edit mode
    useEffect(function () {
        if (configuration && open && itemIndex !== null && itemIndex !== undefined) {
            setSelectedType(configuration.type);
            // Use the specific item at itemIndex for editing
            var editItem = configuration.items[itemIndex];
            if (editItem) {
                setKey(editItem.key);
                // Convert value to string for display
                var displayValue = _typeof(editItem.value) === 'object' ? JSON.stringify(editItem.value, null, 2) : String(editItem.value);
                setValue(displayValue);
                // Determine value type
                if (typeof editItem.value === 'boolean') {
                    setValueType('boolean');
                }
                else if (typeof editItem.value === 'number') {
                    setValueType('number');
                }
                else if (_typeof(editItem.value) === 'object') {
                    setValueType('object');
                }
                else {
                    setValueType('string');
                }
            }
        }
    }, [configuration, open, itemIndex]);
    var handleClose = function handleClose() {
        // Reset form
        setSelectedType('');
        setKey('');
        setValue('');
        setValueType('string');
        setErrors({});
        onClose();
    };
    var validateValueType = function validateValueType(type, val) {
        try {
            if (type === 'number') {
                var num = Number(val);
                if (Number.isNaN(num)) {
                    return constants.configuration_modal_error_number_invalid;
                }
            }
            else if (type === 'boolean') {
                var lower = val.toLowerCase();
                if (lower !== 'true' && lower !== 'false') {
                    return constants.configuration_modal_error_boolean_invalid;
                }
            }
            else if (type === 'object') {
                JSON.parse(val); // This will throw if invalid JSON
            }
            return null;
        }
        catch (_unused) {
            return constants.configuration_modal_error_json_invalid;
        }
    };
    var validateForm = function validateForm() {
        var newErrors = {};
        if (!selectedType) {
            newErrors.type = constants.configuration_modal_error_select_type;
        }
        if (!key.trim()) {
            newErrors.key = constants.configuration_modal_error_key_required;
        }
        if (!value.trim()) {
            newErrors.value = constants.configuration_modal_error_value_required;
        }
        // Validate value based on type
        if (value.trim()) {
            var validationError = validateValueType(valueType, value);
            if (validationError) {
                newErrors.value = validationError;
            }
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    var convertValue = function convertValue(val, type) {
        switch (type) {
            case 'number':
                return Number(val);
            case 'boolean':
                return val.toLowerCase() === 'true';
            case 'object':
                return JSON.parse(val);
            default:
                return val;
        }
    };
    var getButtonText = function getButtonText() {
        if (loading) {
            return isEditMode ? constants.configuration_modal_button_updating : constants.configuration_modal_button_adding;
        }
        return isEditMode ? constants.configuration_modal_button_update : constants.configuration_modal_button_add;
    };
    var handleSubmit = /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
            var updatedItems, updateData, existingConfig, _updatedItems, _updateData, configurationData, _t;
            return _regenerator().w(function (_context) {
                while (1)
                    switch (_context.p = _context.n) {
                        case 0:
                            if (validateForm()) {
                                _context.n = 1;
                                break;
                            }
                            return _context.a(2);
                        case 1:
                            _context.p = 1;
                            setLoading(true);
                            if (!(isEditMode && configuration && itemIndex !== null && itemIndex !== undefined)) {
                                _context.n = 3;
                                break;
                            }
                            // Update existing configuration - update the specific item while keeping others
                            updatedItems = _toConsumableArray(configuration.items);
                            updatedItems[itemIndex] = {
                                key: key.trim(),
                                value: convertValue(value.trim(), valueType)
                            };
                            updateData = {
                                resourceType: 'Configuration',
                                type: selectedType,
                                items: updatedItems,
                                details: configuration.details || {}
                            };
                            _context.n = 2;
                            return ConfigurationAPI.updateConfiguration(configuration.id, updateData);
                        case 2:
                            _context.n = 6;
                            break;
                        case 3:
                            // Adding new item - check if configuration of this type already exists
                            existingConfig = existingConfigurations.find(function (config) {
                                return config.type === selectedType;
                            });
                            if (!existingConfig) {
                                _context.n = 5;
                                break;
                            }
                            // Append to existing configuration's items array
                            _updatedItems = [].concat(_toConsumableArray(existingConfig.items), [{
                                    key: key.trim(),
                                    value: convertValue(value.trim(), valueType)
                                }]);
                            _updateData = {
                                resourceType: 'Configuration',
                                type: selectedType,
                                items: _updatedItems,
                                details: existingConfig.details || {}
                            };
                            _context.n = 4;
                            return ConfigurationAPI.updateConfiguration(existingConfig.id, _updateData);
                        case 4:
                            _context.n = 6;
                            break;
                        case 5:
                            // Create new configuration
                            configurationData = {
                                resourceType: 'Configuration',
                                type: selectedType,
                                items: [{
                                        key: key.trim(),
                                        value: convertValue(value.trim(), valueType)
                                    }],
                                details: {}
                            };
                            _context.n = 6;
                            return ConfigurationAPI.createConfiguration(configurationData);
                        case 6:
                            onSaved();
                            handleClose();
                            _context.n = 8;
                            break;
                        case 7:
                            _context.p = 7;
                            _t = _context.v;
                            setErrors({
                                submit: isEditMode ? constants.configuration_modal_submit_update_failed : constants.configuration_modal_submit_create_failed
                            });
                        case 8:
                            _context.p = 8;
                            setLoading(false);
                            return _context.f(8);
                        case 9:
                            return _context.a(2);
                    }
            }, _callee, null, [[1, 7, 8, 9]]);
        }));
        return function handleSubmit() {
            return _ref2.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: handleClose,
        maxWidth: "sm",
        fullWidth: true,
        sx: {
            '& .MuiDialog-paper': {
                borderRadius: 2,
                minHeight: 400
            }
        }
    }, /*#__PURE__*/ React.createElement(DialogTitle, {
        sx: {
            fontSize: '20px',
            fontWeight: 600,
            color: '#212121',
            pb: 1
        }
    }, isEditMode ? constants.configuration_modal_title_edit : constants.configuration_modal_title_add), /*#__PURE__*/ React.createElement(Divider, null), /*#__PURE__*/ React.createElement(DialogContent, {
        sx: {
            py: 3
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
            width: '100%'
        }
    }, /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(TextField, {
        select: true,
        fullWidth: true,
        label: /*#__PURE__*/ React.createElement(Box, {
            component: "span"
        }, constants.configuration_modal_field_system, ' ', /*#__PURE__*/ React.createElement(Box, {
            component: "span",
            sx: {
                color: '#da291c'
            }
        }, "*")),
        value: selectedType,
        onChange: function onChange(e) {
            return setSelectedType(e.target.value);
        },
        error: !!errors.type,
        helperText: errors.type,
        size: "medium",
        sx: {
            '& .MuiOutlinedInput-root': {
                borderRadius: 1
            }
        }
    }, Object.entries(CONFIGURATION_TYPE_LABELS).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2), optionKey = _ref4[0], label = _ref4[1];
        return /*#__PURE__*/ React.createElement(MenuItem, {
            key: optionKey,
            value: optionKey
        }, label);
    }))), /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(TextField, {
        fullWidth: true,
        label: /*#__PURE__*/ React.createElement(Box, {
            component: "span"
        }, constants.configuration_modal_field_key, ' ', /*#__PURE__*/ React.createElement(Box, {
            component: "span",
            sx: {
                color: '#da291c'
            }
        }, "*")),
        placeholder: constants.configuration_modal_field_key,
        value: key,
        onChange: function onChange(e) {
            return setKey(e.target.value);
        },
        error: !!errors.key,
        helperText: errors.key,
        size: "medium",
        sx: {
            '& .MuiOutlinedInput-root': {
                borderRadius: 1
            }
        }
    })), /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(TextField, {
        select: true,
        fullWidth: true,
        label: /*#__PURE__*/ React.createElement(Box, {
            component: "span"
        }, constants.configuration_modal_field_value_type, ' ', /*#__PURE__*/ React.createElement(Box, {
            component: "span",
            sx: {
                color: '#da291c'
            }
        }, "*")),
        value: valueType,
        onChange: function onChange(e) {
            return setValueType(e.target.value);
        },
        error: !!errors.valueType,
        helperText: errors.valueType,
        size: "medium",
        sx: {
            '& .MuiOutlinedInput-root': {
                borderRadius: 1
            }
        }
    }, Object.entries(VALUE_TYPE_LABELS).map(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2), typeKey = _ref6[0], label = _ref6[1];
        return /*#__PURE__*/ React.createElement(MenuItem, {
            key: typeKey,
            value: typeKey
        }, label);
    }))), /*#__PURE__*/ React.createElement(Box, null, valueType === 'object' ? /*#__PURE__*/ React.createElement(TextField, {
        fullWidth: true,
        multiline: true,
        minRows: 10,
        maxRows: 24,
        label: /*#__PURE__*/ React.createElement(Box, {
            component: "span"
        }, constants.configuration_modal_field_value, ' ', /*#__PURE__*/ React.createElement(Box, {
            component: "span",
            sx: {
                color: '#da291c'
            }
        }, "*")),
        placeholder: constants.configuration_modal_field_value,
        value: value,
        onChange: function onChange(e) {
            return setValue(e.target.value);
        },
        error: !!errors.value,
        helperText: errors.value,
        variant: "outlined",
        sx: {
            '& .MuiOutlinedInput-root': {
                fontFamily: 'monospace',
                fontSize: '14px',
                lineHeight: 1.62,
                borderRadius: 1,
                alignItems: 'flex-start',
                // Let MUI handle background and padding
                '& fieldset': {
                    border: '2px solid #26890D'
                }
            },
            '& .MuiOutlinedInput-root.Mui-focused fieldset': {
                borderColor: '#1e6b0a'
            },
            '& .MuiOutlinedInput-root.Mui-error fieldset': {
                borderColor: '#da291c'
            },
            '& .MuiInputBase-input': {
                fontFamily: 'monospace',
                fontSize: '14px',
                lineHeight: 1.62,
                padding: '16px',
                minHeight: '180px',
                resize: 'vertical',
                overflow: 'auto'
            }
        }
    }) : /*#__PURE__*/ React.createElement(TextField, {
        fullWidth: true,
        label: /*#__PURE__*/ React.createElement(Box, {
            component: "span"
        }, constants.configuration_modal_field_value, ' ', /*#__PURE__*/ React.createElement(Box, {
            component: "span",
            sx: {
                color: '#da291c'
            }
        }, "*")),
        placeholder: constants.configuration_modal_field_value,
        value: value,
        onChange: function onChange(e) {
            return setValue(e.target.value);
        },
        error: !!errors.value,
        helperText: errors.value,
        size: "medium",
        sx: {
            '& .MuiOutlinedInput-root': {
                borderRadius: 1
            }
        }
    })), errors.submit && /*#__PURE__*/ React.createElement(Typography, {
        color: "error",
        variant: "body2"
    }, errors.submit))), /*#__PURE__*/ React.createElement(DialogActions, {
        sx: {
            p: 3,
            pt: 0,
            display: 'flex',
            justifyContent: 'space-between',
            gap: 2
        }
    }, /*#__PURE__*/ React.createElement(Button, {
        onClick: handleClose,
        sx: {
            color: '#26890D',
            textTransform: 'none',
            fontWeight: 600,
            '&:hover': {
                backgroundColor: 'rgba(38, 137, 13, 0.04)'
            }
        }
    }, constants.cancel), /*#__PURE__*/ React.createElement(Button, {
        onClick: handleSubmit,
        disabled: loading || !selectedType || !key.trim() || !value.trim(),
        variant: "contained",
        sx: {
            backgroundColor: '#26890D',
            textTransform: 'none',
            fontWeight: 600,
            '&:hover': {
                backgroundColor: '#1e6b0a'
            },
            '&:disabled': {
                backgroundColor: 'rgba(38, 137, 13, 0.4)',
                color: '#fff'
            }
        }
    }, getButtonText())));
};
export default AddConfigurationModal;
